<template>

  <section>

    <b-tabs v-model="activeTab" @change="loadTabById" ref="tabs">

        <!-- <b-tab-item label="Details">

          <organization-form :organization.sync="selectedOrganization" v-if="isTabLoaded(0)" :selectedFirm.sync="selectedFirm"

          @refetchOrganization="refetchOrganization" @refetchFirm="refetchFirm" @updateOrganization="updateOrganization"  @updateFirm="updatFirm"

          :organizations="organizations" @reset="reset"/>

        </b-tab-item> -->

        <b-tab-item label="Personnel" id="tab-personnel">
        <!-- <b-tab-item label="Personnel" id="tab-personnel" v-if="$store.getters['Auth/hasPermission']('can manage personnel')"> -->

            <div class="columns is-gapless" v-if="isTabLoaded('tab-personnel')">

                <div class="column is-6">

                    <persons :selectedOrganization.sync="selectedOrganization" :createUser.sync="createUser" :person.sync="person"

                        :archivedAt="archivedAt" ref="person" v-if="selectedFirm && selectedOrganization" :keyword.sync="keyword"

                        @fetch="onPersonsFetch"
                    />

                </div>

                <div class="column is-6">

                    <div style="height:calc(100vh - 50px - 126px); padding: 0; overflow: auto;">

                        <user-form :organization="selectedOrganization" :user.sync="person" @close="person = null" ref="userForm"

                            @callback="userFormCallback" v-if="selectedOrganization" :keyword="keyword"

                            @update-tags="onUserUpdateTags"

                            :is-first="isFirstUser"
                        />

                    </div>

                </div>

            </div>

        </b-tab-item>

        <!-- <b-tab-item label="Permissions" id="tab-permissions" v-if="$store.getters['Auth/hasPermission']('can manage firm permissions')">

          <organization-permission :organization="selectedOrganization" @update-success="updatFirm" v-if="isTabLoaded('tab-permissions')" />

        </b-tab-item> -->

        <b-tab-item label="Documents" id="tab-document">
        <!-- <b-tab-item label="Documents" id="tab-document" v-if="$store.getters['Auth/hasPermission']('can manage document')"> -->

            <file-list :model="selectedOrganization" modelType="firm" :viewer="viewer" :form="!!form" :selectable="selectable" v-if="isTabLoaded('tab-document')" />

        </b-tab-item>

        <!-- <b-tab-item label="Brand" id="tab-brand" v-if="$store.getters['Auth/hasPermission']('can manage brand')">
            <div class="columns" v-if="isTabLoaded('tab-brand')">
                <div class="column is-6">

            <form enctype="multipart/form-data" ref="form">

                <div class="columns">

                    <div class="column">

                          <b-field label="Logo">

                            <b-upload v-model="logo" accept="image/*">

                              <b-button icon-left="upload" tag="a">

                                <span>{{ logo ? logo.name : "Choose File" }}</span>

                              </b-button>

                            </b-upload>

                          </b-field>

                        <div v-if="selectedFirm.firm.logo" class="image-logo" style="max-width:400px;">

                          <figure class="image is-fullwidth">

                            <img :src="selectedFirm.firm.logo.path" ref="imageLogo" class="logo">

                          </figure>

                        </div>
                    </div>

                </div>

                <b-field label="Code">

                    <b-input v-model="form.councilId"></b-input>

                </b-field>

                <br>

                <base-tag-input
                    attach-mode
                    :value="reverseAssociation ? reverseAssociation.tags : []"
                    model-type="firm_association"
                    :model-id="reverseAssociation ? reverseAssociation.id : null"
                    :type="!reverseAssociation ? 'is-danger' : ''"
                    :message="!reverseAssociation ? 'No reverse association' : ''"
                    :disabled="!reverseAssociation"
                />

                <br>

                <b-field label="Your Rating" v-if="selectedOrganization" class="rating-div">

                    <star-rating class="mb-1" :increment ="0.1" :rating="doneRate.rating" :star-size="20" :show-rating="false" read-only v-if="doneRate"/>

                    <star-rating class="mb-1" :increment ="0.1" :rating="0" :star-size="20" :show-rating="false" read-only v-else />

                    <template v-if="canRate && !doneRate">

                        <button class="button rate-button" type="button" @click="modal.active = true">Rate</button>

                        <b-modal :active.sync="modal.active" has-modal-card>

                            <rating-modal :rate="rate" />

                        </b-modal>

                    </template>

                    <p v-if="selectedOrganization.ratings.length && doneRate">Notes: {{ doneRate.notes }}</p>

                </b-field>

                <br>

                <button type="button" class="button is-info is-fullwidth" @click="saveLogo">Save</button>

            </form>

                </div>

                <div class="column is-6">
                    <portal-form :portal.sync="portal" :model="selectedOrganization" />
                </div>
            </div>




        </b-tab-item> -->
        
        <!-- Moved 'Rates' tab under 'System' tab -->
        <!-- <b-tab-item label="Rates" id="tab-rates" v-if="$store.getters['Auth/hasPermission']('can manage rates')">
            <organization-rates :organization="selectedOrganization" :firm="selectedFirm" v-if="isTabLoaded('tab-rates')" />
        </b-tab-item> -->
        <!-- END - Moved 'Rates' tab under 'System' tab -->

        <!-- Moved 'Contracts' tab under 'System' tab -->
        <!-- <b-tab-item label="Contracts" id="tab-contracts" v-if="selectedOrganization.id == user.firmId && !selectedOrganization.managed_by && $store.getters['Auth/hasPermission']('can manage contracts')"> -->

            <!-- <organization-contracts :organization="selectedOrganization" :firm="selectedFirm" v-if="isTabLoaded('tab-contracts')" /> -->

            <!-- <div style="text-align:center;">

                <button :class="'button firm-role-button ' + (firmHasRole('vendor') ? 'is-info' : '')" @click="toggleRole('vendor')">VENDOR</button>

                <button :class="'button firm-role-button ' + (firmHasRole('customer') ? 'is-info' : '')" @click="toggleRole('customer')">CUSTOMER</button>

            </div> -->

            <!-- <div v-if="firmTags.length" style="text-align:center;">

                <button :class="(tagExist(tag.id) ? 'is-info' : '') + ' button tags-button'"

                :disabled="selectedFirm.archived_at" v-for="(tag, key) in firmTags"

                @click.prevent="firmTag(tag, $event)">{{ tag.name }} </button>

            </div> -->

        <!-- </b-tab-item> -->
        <!-- END - Moved 'Contracts' tab under 'System' tab -->

        <!-- <b-tab-item label="Codes"> -->
            <!-- <Codes :organization="selectedOrganization" :firm="selectedFirm" v-if="isTabLoaded(4)" /> -->
            <!-- <organization-code :organization="selectedOrganization" :firm="selectedFirm" v-if="isTabLoaded(4)" /> -->
        <!-- </b-tab-item> -->
        <!-- <b-tab-item label="Notifications"> -->
            <!-- <notifications v-if="isTabLoaded(5)" :type="" /> -->
        <!-- </b-tab-item> -->
<!--         <b-tab-item label="Terminology">
            <terminology v-if="isTabLoaded(6)" />
        </b-tab-item>
        <b-tab-item label="Roles" v-if="! managedByOtherFirm">
            <organization-roles :organization="selectedOrganization" :firm="selectedFirm" @refetchRoles="refetchRoles" v-if="isTabLoaded(7)" />
        </b-tab-item> -->

        <b-tab-item label="Vetted Notes" id="tab-vetted-notes" v-if="!selectedOrganization.managed_by && $store.getters['Auth/hasPermission']('can manage vetted notes')">

            <vetted-statement :organization="selectedOrganization" v-if="isTabLoaded('tab-vetted-notes')" />
        </b-tab-item>

        <b-tab-item label="System" id="tab-system" v-if="!selectedOrganization.managed_by && selectedOrganization.id == user.firmId && $store.getters['Auth/hasPermission']('can manage system')">

            <organization-settings :organization.sync="selectedOrganization" :selectedFirm.sync="selectedFirm"

             @updateOrganization="updateOrganization"  @updateFirm="updatFirm" @refetchRoles="refetchRoles" v-if="isTabLoaded('tab-system')" />

        </b-tab-item>

    </b-tabs>

  </section>

</template>

<script>

import OrganizationForm from "./organizationForm";
import { tabsMixin } from "@/mixins/tabsMixin";
// import OrganizationPermission from "./organizationPermission";
import FileList from "@/components/File/FileList";
import OrganizationSettings from "./organizationSettings";
// import OrganizationContracts from "@/components/pages/Contracts/index";
// import organizationRates from "./organizationRates";
// import organizationRoles from "./organizationRoles";
// import Codes from "./codes";
// import organizationCode from "./organizationCode";
// import Terminology from "@/components/Terminology/Terminology";
import Persons from "../persons";
import UserForm from "../persons/userForm";
import { TagService } from "@/services/tag.service";
import { FirmService } from "@/services/firm.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
// import Notifications from "@/components/pages/Notifications/list/index";
import TagsInput from "@/components/partials/TagsInput";
import StarRating from "vue-star-rating";
import RatingModal from "@/components/Rating/RatingModal";
import PortalForm from "@/components/pages/Portals/partials/organizationPortalForm";
import VettedStatement from "@/components/pages/VettedStatement/list";
import BaseTagInput from "@/components/partials/BaseTagInput";

export default {
    components: {
        OrganizationForm,
        // OrganizationPermission,
        FileList,
        OrganizationSettings,
        // OrganizationContracts,
        Persons,
        UserForm,
        // organizationRates,
        TagsInput,
        StarRating,
        RatingModal,
        PortalForm,
        VettedStatement,
        // organizationRoles,
        // Notifications,
        // organizationCode,
        // Terminology,
        // Codes,
        BaseTagInput,
    },
    props: ['selectedOrganization', 'selectedFirm', 'organizations'],
    mixins: [tabsMixin],
    data() {

        return {
            logo: null,
            form: {
              councilId: "",
              tags: []
            },
            modal: {
                active: false
            },
            currentTags: null,

            activeTab: 0,

            firmTags: [],

            activeTags: {},

            // from persons/index

            createUser: false,

            person: null,

            archivedAt: false,

            viewer: true,

            selectable: true,

            keyword: '',

            portal: null,

            reverseAssociation: null, // Reverse of selectedFirm (firm_firm)

            isFirstUser: false,

        }

    },

    computed: {
        user() {
            return this.$store.state.Auth.user;
        },
        managedByOtherFirm() {
            return this.selectedOrganization.managed_by;
        },
        selectedtags: {
            get() {
                return this.selectedFirm.tags.filter(element => this.firmTags.every(tag => tag.id != element.id)).map(element => element.name);
            }, set(value) {
                this.currentTags = value;
            }
        },
        doneRate() {
            return this.selectedOrganization.ratings.find(element => {
                return element.createdBy == this.user.id;
            });
        },
        canRate() {
            return this.$store.getters["Auth/hasFirmPermission"]("can rate firms");
        },
        isSuperAdmin() {
            return this.$store.getters["Auth/hasRole"]('superadmin');
        },
        isSuperFirmAdmin() {
            return this.$store.getters["Auth/hasRole"]('super-firm-admin');
        },
    },

    watch: {
        selectedFirm() {
            this.person = null;
            this.form = {
                councilId: this.selectedFirm.code,
            }
            this.firmHasPortal();
            this.getReverseAssociation();
        }
    },

    methods: {
        async rate(data) {
            await FirmService.rate(this.selectedOrganization.id, data).then(response => {
                // this.$emit('updateOrganization', JsonDenormalizer.denormalize(response))
                // this.modal.active = false;
            });
        },

        transformedData() {

          let formData = new FormData(this.$refs.form);

          formData.append("file", this.logo);

          formData.append("firm_firm_id", this.selectedFirm.id);

          formData.append("firm_id", this.selectedOrganization.id);

          formData.append("code", this.form.councilId);

          formData.append("tags", this.currentTags.toString());

          let active_tags = [];

          Object.entries(this.activeTags).forEach(([key, value]) => {

            active_tags.push(value);

          });

          formData.append("active_tags", active_tags.toString());

          return formData;

        },

        refetchRoles() {
            this.$refs.userForm.getRoles();
        },

        refetchOrganization() {

            this.$emit('refetchOrganization');

        },


        refetchFirm() {

            this.$emit('refetchFirm');

        },

        updateOrganization(organization){

            this.$emit('refetchOrganization');

            this.$emit('update:selectedOrganization', organization)

        },

        updatFirm(firm){

            this.$emit('refetchFirm');

            if (firm) {

                this.$emit('update:selectedFirm', firm)

            }

        },

        getTags() {

            TagService.findtags({tags: ['customer', 'vendor']}).then(response => {

                this.firmTags = JsonDenormalizer.denormalize(response);

            });

        },


        tagExist(id) {

            let data = this.selectedFirm.tags.filter(element => element.id == id && element.archived_at == null);

            if (data.length) {

                this.activeTags[id] = data[0].id;

                return true;

            }

            return false;

        },

        firmTag(tag, event) {

            event.target.classList.toggle('is-loading');

            TagService.attachtag({tag: tag.id, parent_id: this.user.firmId, child_id: this.selectedOrganization.id}).then(response => {

                event.target.classList.toggle('is-info');

                event.target.classList.toggle('is-loading');

                this.updatFirm(response);

            });

        },

        reset() {

            this.$parent.reset();

        },

        onUserUpdateTags() {
            this.$refs.person.refetch();
        },

        async userFormCallback(data){
            this.person = data ? data : null;
            await this.$refs.person.refetch();
            this.$refs.person.selectedUser = data ? data : null;

        },

        toggleRole(type) {

            FirmService.attachRole({id: this.selectedFirm.id, type: type}).then(response => {

                this.$emit('update:selectedFirm', response);

                this.$parent.refetchFirm();

                this.$buefy.toast.open({

                    message: 'Associated Organization Role successfully updated.',

                    type: "is-info",

                    position: "is-top-right"

                });


            });


        },

        firmHasRole(role) {

            return this.selectedFirm.roles.find(element => element.name.toLowerCase() == role);

        },


        saveLogo() {

          FirmService.updateLogo(this.transformedData()).then(response => {

              let firm = JsonDenormalizer.denormalize(response);

              this.$buefy.toast.open({
                message: "Successfully updated.",
                type: "is-info",
                position: "is-top-right"
              });

              // if (true) {}
              // console.log(firm);

              // console.log(this.$refs.imageLogo.src = 'sdadas')

//               selectedOrganization
// selectedFirm

                this.$emit('updateLogo', response)

              // this.$emit('update:selectedOrganization', firm);

              this.logo = null;

          });

        },

        firmHasPortal() {
            FirmService.show(this.selectedOrganization.id, {includes: 'portal'}).then(response => {
                let organization = JsonDenormalizer.denormalize(response);
                this.portal = organization.portal || null
            });
        },
        async getReverseAssociation() {
            // This is for the tag input
            // Need to attach tags to firm_firm->parent = selected_firm AND firm_firm->child = auth_user->firm
            this.reverseAssociation = null;

            const data = await FirmService.firmAssociations({
                    parent_id: this.selectedOrganization.id,
                    child_id: this.user.firmId,
                    includes: "tags"
                })
                .then(response => JsonDenormalizer.denormalize(response));

            if (data.length) {
                this.reverseAssociation = data[0];
            }
        },

        onPersonsFetch(users) {
            this.isFirstUser = users.filter(v => !v.archivedAt).length === 0;
        },
    },

    mounted() {

        // Load initial tab
        this.loadTabById(0);

        // this.getTags();

        // this.form = {
        //     councilId: this.selectedFirm.code,
        // }

        // this.firmHasPortal();
        // this.getReverseAssociation();


    }

};

</script>

<style scoped>

    .firm-role-button{
        width: 225px;
        margin-top: 20px;
        margin-left: 5px;
        text-align: center;
    }

    .tabs ul {
        border: 0;
    }


</style>


// WEBPACK FOOTER //
// src/components/pages/Organization/organizationData/organizationDetails.vue